/* eslint-disable no-restricted-syntax */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import format from 'date-fns/format';
import _get from 'lodash.get';
import s from './HeadToHeadMatchesList.scss';
import MatchCardInfoSlider from '../../../../../components_v2/common/MatchCardInfoSlider/MatchCardInfoSlider';
import MatchSquadList from '../MatchSquadList/MatchSquadList';
import MatchStatsList from '../MatchStatsList/MatchStatsList';
import CricketRanking from '../CricketRanking/CricketRanking';
import MatchInfoCard from '../../../../../components_v2/common/MatchInfoCard/MatchInfoCard';
import makeRequest from '../../../../../utils/makeRequest';
import LoaderSpinner from '../../../../../components_v2/common/LoaderSpinner/LoaderSpinner';
//import { Link } from '@material-ui/core';

//import { Link } from '@material-ui/core';

const HeadToHeadMatchesList = props => {
  if (props?.sectionItem) {
    const {
      endedMatchSlider,
      upcomingMatchSlider,
      livematch_url,
      matchSquadData,
      teamaid,
      teambid,
      teamashrt_name,
      teambshrt_name,
      teamaname,
      teambname,
      matchStatsData,
      deviceType,
      thumbUrl,
    } = props?.sectionItem;
    const slideToShow = props?.isWapView ? 1 : 3;
    const [livematches, setlivematches] = useState([]);
    const [groupData, setgroupData] = useState([]);
    const [activeFeedNodeName, setActiveFeedNodeName] = useState('ODI');
    const [activeMatchStatNode, setactiveMatchStatNode] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [thumbslist, SetThumbslist] = useState(null);
    const createClassNameforWap = matches =>
      classnames({
        [`${s.match_slider_wrapper}`]: true,
        [`${s.singleCardslider}`]:
          matches && Array.isArray(matches) && matches.length === 1,
      });
    const setInitialGroupData = () => {
      if (matchStatsData) {
        const grpdata = [];
        for (const matchType in matchStatsData?.[teamaid]) {
          grpdata.push({
            link: matchType,
            name: matchType.toLowerCase(),
          });
        }
        setgroupData(grpdata);
        onGroupTabsChange(grpdata[0]);
      }
    };
    const onGroupTabsChange = dataObj => {
      if (dataObj && dataObj?.link && dataObj?.name) {
        // setActiveGroupTab(dataObj?.name);
        setActiveFeedNodeName(dataObj.name);
        if (matchStatsData) {
          const localStatsData = {};
          const statsTeamAdata = matchStatsData?.[teamaid]?.[dataObj.link]
            ? matchStatsData[teamaid][dataObj.link]
            : matchStatsData?.[teamaid];
          const statsTeamBdata = matchStatsData?.[teambid]?.[dataObj.link]
            ? matchStatsData[teambid][dataObj.link]
            : matchStatsData?.[teambid];
          localStatsData[teamaid] = statsTeamAdata;
          localStatsData[teambid] = statsTeamBdata;
          setactiveMatchStatNode(localStatsData);
        }
      }
    };

    const getMatchesData = month => {
      try {
        let teama;
        let teamb;
        if (livematch_url) {
          makeRequest
            .get(livematch_url, 'skipfeedengine')
            // eslint-disable-next-line consistent-return
            .then(result => {
              if (result?.data?.matches) {
                const liveMatches = result?.data?.matches
                  .filter(match => {
                    const matchDate = match?.start_date;
                    const endMatchDate = match?.end_date;
                    const coveragelevel = match?.event_coverage_level_id;
                    const firstTeamid =
                      match?.participants &&
                      Array.isArray(match?.participants) &&
                      match?.participants.length > 0
                        ? match?.participants[0]?.id
                        : '';
                    const secTeamid =
                      match?.participants &&
                      Array.isArray(match?.participants) &&
                      match?.participants.length > 1
                        ? match?.participants[1]?.id
                        : '';
                    if (
                      ((firstTeamid === teamaid && secTeamid === teambid) ||
                        (secTeamid === teamaid && firstTeamid === teambid)) &&
                      coveragelevel === '8' &&
                      matchDate &&
                      typeof matchDate === 'string' &&
                      typeof endMatchDate === 'string'
                    ) {
                      const matchDateArr = matchDate.split('-');
                      const endmatchDateArr = endMatchDate.split('-');
                      if (
                        (matchDateArr &&
                          Array.isArray(matchDateArr) &&
                          matchDateArr.length > 1) ||
                        (endmatchDateArr &&
                          Array.isArray(endmatchDateArr) &&
                          endmatchDateArr.length > 1)
                      ) {
                        if (
                          month === parseInt(matchDateArr[1], 10) ||
                          month === parseInt(endmatchDateArr[1], 10)
                        ) {
                          // eslint-disable-next-line no-prototype-builtins
                          const matchSeriesNameUrl =
                            match?.series_name &&
                            typeof match?.series_name === 'string'
                              ? match?.series_name
                                  .replace(/,/g, '')
                                  .replace(/\//g, '-')
                                  .replace(/ /g, '-')
                              : '';
                          return match;
                        }
                      }
                    }
                  })
                  .map(match => {
                    if (
                      match?.participants &&
                      Array.isArray(match?.participants) &&
                      match?.participants.length > 0
                    ) {
                      teama = match?.participants[0]?.name;
                      teamb = match?.participants[1]?.name;
                      match.participants = match.participants.map(
                        participant => {
                          if (
                            match?.event_format &&
                            match?.event_format.toLowerCase() === 'test' &&
                            participant?.value &&
                            typeof participant?.value === 'string'
                          ) {
                            const scoreArr = participant.value.split(' & ');
                            const result = [];
                            if (
                              scoreArr &&
                              Array.isArray(scoreArr) &&
                              scoreArr.length > 0
                            ) {
                              scoreArr.forEach(inngs => {
                                if (inngs && typeof inngs === 'string') {
                                  const inngArr = inngs.split(' ');
                                  if (
                                    inngArr &&
                                    Array.isArray(inngArr) &&
                                    inngArr.length > 0
                                  ) {
                                    result.push(inngArr[0]);
                                  }
                                }
                              });
                            }
                            participant.inngscore = result;
                            delete participant.value;
                          }
                          if (participant?.highlight) {
                            participant.winingteam = true;
                          }
                          return participant;
                        },
                      );
                    }
                    match.venueUrl = `/sports/cricket/venues/${
                      match?.venue_id
                    }/${match?.venue_name}`;
                    if (
                      match?.event_status &&
                      match?.event_status.toLowerCase().includes('match begins')
                    ) {
                      match.event_status = 'Match Yet To Begin';
                    }
                    if (
                      match?.event_status &&
                      match?.event_status.toLowerCase().includes('toss')
                    ) {
                      match.event_status = 'Play In Progress';
                    }
                    match.cardurl = `/sports/cricket/match-center-scorecard/${teama}-vs-${teamb}-live-score-update-${
                      match?.series_name
                        ? match?.series_name
                            .toLowerCase()
                            .replace(/[ ]/g, '-')
                            .replace(',', '')
                            .replace('/', '-')
                        : ''
                    }/${match?.game_id}`;
                    match.cardurl = makeRequest.removeCommas(match.cardurl);
                    match.matchfile = match?.game_id;
                    return match;
                  });
                setlivematches(liveMatches);
                setIsLoading(false);
              }
              // this.setState({ isLoading: false });
              setIsLoading(false);
            })
            .catch(() => {
              // console.log(error);
            });
        }
      } catch (e) {
        // console.log(error);
        setIsLoading(false);
      }
    };
    const createNoSlickSlider = matchesData => {
      const clsnameforcard = classnames({
        [`${s.item}`]: props && props.isWapView,
        [`${s.match_slider_wrapper}`]: props && !props.isWapView,
      });
      return matchesData.map(match => {
        const isLiveMatch =
          match &&
          match.event_status &&
          match.event_status.toLowerCase() === 'play in progress';
        const isUpcomingMatch =
          match &&
          match.event_status &&
          (match.event_status.toLowerCase() === 'match yet to begin' ||
            match.event_status.toLowerCase().includes('match begin'));
        const isMatchEnded =
          match &&
          match.event_status &&
          (match.event_status.toLowerCase() === 'match ended' ||
            match.event_status.toLowerCase() === 'match abandoned');
        return (
          <div className={clsnameforcard}>
            <MatchInfoCard
              isLiveMatch={isLiveMatch}
              isUpcomingMatch={isUpcomingMatch}
              isMatchEnded={isMatchEnded}
              data={match}
              seriesname="Schedule"
              isLanding
            />
          </div>
        );
      });
    };
    useEffect(() => {
      setInitialGroupData();
      const date = new Date();
      const month = date.getMonth() + 1;
      getMatchesData(month);
      const url = thumbUrl;
      makeRequest
        .get(url, { isMobile: props.isWapView }, 'skipfeedengine')
        .then(result => {
          if (result?.data) {
            SetThumbslist(result?.data?.playerthumbs?.data);
          }
        });
    }, []);

    return (
      <div className={s.headToHead}>
        {livematches &&
          Array.isArray(livematches) &&
          livematches.length > 0 && (
            <div className={s.liveMatchSection}>
              <h2>Live Matches</h2>
              <div>
                {isLoading && <LoaderSpinner />}
                {!props?.isWapView &&
                  livematches.length > 3 && (
                    <MatchCardInfoSlider
                      items={livematches}
                      slideToShow={slideToShow}
                      isLanding
                    />
                  )}
                {!props?.isWapView &&
                  livematches.length <= 3 && (
                    <div className={s.card_wrapper}>
                      {createNoSlickSlider(livematches)}
                    </div>
                  )}
                {props?.isWapView && (
                  <div className={createClassNameforWap(livematches)}>
                    {createNoSlickSlider(livematches)}
                  </div>
                )}
              </div>
            </div>
          )}

        {upcomingMatchSlider &&
          Array.isArray(upcomingMatchSlider) &&
          upcomingMatchSlider.length > 0 && (
            <div className={s.upcomingMatchSection}>
              <h2>
                {teamashrt_name ? teamashrt_name.toUpperCase() : ''} vs{' '}
                {teambshrt_name ? teambshrt_name.toUpperCase() : ''} Upcoming
                Matches
              </h2>
              <div className={s.landingscorecard}>
                {!props?.isWapView &&
                  upcomingMatchSlider.length > 3 && (
                    <MatchCardInfoSlider
                      items={upcomingMatchSlider}
                      slideToShow={slideToShow}
                      isLanding
                      // seriesname={componentData.heading}
                    />
                  )}
                {!props?.isWapView &&
                  upcomingMatchSlider.length <= 3 && (
                    <div className={s.card_wrapper}>
                      {createNoSlickSlider(upcomingMatchSlider)}
                    </div>
                  )}
                {props?.isWapView && (
                  <div className={createClassNameforWap(upcomingMatchSlider)}>
                    {createNoSlickSlider(upcomingMatchSlider)}
                  </div>
                )}
              </div>
            </div>
          )}

        {endedMatchSlider &&
          Array.isArray(endedMatchSlider) &&
          endedMatchSlider.length > 0 && (
            <div className={s.endedMatchSection}>
              <h2>
                {teamashrt_name ? teamashrt_name.toUpperCase() : ''} vs{' '}
                {teambshrt_name ? teambshrt_name.toUpperCase() : ''} Completed
                Matches
              </h2>
              <div className={s.landingscorecard}>
                {!props?.isWapView &&
                  endedMatchSlider.length > 3 && (
                    <MatchCardInfoSlider
                      items={endedMatchSlider}
                      slideToShow={slideToShow}
                      slidesToScroll={slideToShow}
                      centerMode={false}
                      isLanding
                      // seriesname={componentData.heading}
                    />
                  )}
                {!props?.isWapView &&
                  endedMatchSlider.length <= 3 && (
                    <div className={s.card_wrapper}>
                      {createNoSlickSlider(endedMatchSlider)}
                    </div>
                  )}
                {props?.isWapView && (
                  <div className={createClassNameforWap(endedMatchSlider)}>
                    {createNoSlickSlider(endedMatchSlider)}
                  </div>
                )}
              </div>
            </div>
          )}

        {matchStatsData && (
          <>
            {groupData &&
              Array.isArray(groupData) &&
              groupData.length > 0 && (
                <div className="matchCentertab">
                  <CricketRanking
                    groupData={groupData}
                    onGroupTabsChange={onGroupTabsChange}
                    cricketRanking=""
                    currentTab={activeFeedNodeName}
                    hideTabs=""
                  />
                </div>
              )}
            <div className={s.matchStatList}>
              <div className={s.matchStat}>
                <MatchStatsList
                  matchStatsData={activeMatchStatNode}
                  teamaid={teamaid}
                  teambid={teambid}
                  teamashrt_name={teamashrt_name}
                  teambshrt_name={teambshrt_name}
                  teamaname={teamaname}
                  teambname={teambname}
                  thumbUrl={thumbUrl}
                  thumbslist={thumbslist}
                />
              </div>
            </div>
          </>
        )}
        {matchSquadData &&
          Array.isArray(matchSquadData) &&
          matchSquadData.length > 0 && (
            <div className={s.matchSquadSection}>
              <MatchSquadList
                matchSquadData={matchSquadData}
                teamaid={teamaid}
                teambid={teambid}
                teamashrt_name={teamashrt_name}
                teambshrt_name={teambshrt_name}
                teamaname={teamaname}
                teambname={teambname}
                deviceType={deviceType}
                thumbUrl={thumbUrl}
                thumbslist={thumbslist}
              />
            </div>
          )}
      </div>
    );
  }
};
HeadToHeadMatchesList.propTypes = {
  sectionItem: PropTypes.objectOf({}),
  deviceType: PropTypes.string,
  isWapView: PropTypes.bool,
};
HeadToHeadMatchesList.defaultProps = {
  sectionItem: {},
  deviceType: '',
  isWapView: false,
};

export default HeadToHeadMatchesList;
